import * as React from 'react';
import { cn } from '../../lib/utils';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from './table';

function DataTable({ columns, data, emptyMessage = 'Nenhum registro encontrado.', getRowId, className, bodyClassName }) {
  const rows = Array.isArray(data) ? data : [];

  return (
    <div className={cn('tw-w-full tw-overflow-x-auto', className)}>
      <Table className="tw-min-w-full">
        <TableHeader>
          <TableRow>
            {columns.map((column) => (
              <TableHead key={column.id || column.accessorKey} className={column.headerClassName}>
                {typeof column.header === 'function' ? column.header() : column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody className={bodyClassName}>
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columns.length} className="tw-text-center tw-text-sm tw-text-slate-500 dark:tw-text-slate-400">
                {emptyMessage}
              </TableCell>
            </TableRow>
          )}
          {rows.map((row, rowIndex) => {
            const rowKey = getRowId ? getRowId(row, rowIndex) : row.id ?? rowIndex;
            return (
              <TableRow key={rowKey}>
                {columns.map((column) => {
                  const key = column.id || column.accessorKey || column.header || rowIndex;
                  const value =
                    typeof column.accessorFn === 'function'
                      ? column.accessorFn(row, rowIndex)
                      : column.accessorKey
                      ? row[column.accessorKey]
                      : undefined;
                  const content =
                    typeof column.cell === 'function'
                      ? column.cell({ row, value, rowIndex })
                      : value ?? column.emptyValue ?? '-';
                  return (
                    <TableCell key={key} className={column.className}>
                      {content}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

export { DataTable };
